<template>
  <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :label-width="'80px'" :get-action="queryApi" :serial="serial" :selection="selection" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
    <template v-slot:baseForm>
      <!-- <el-col :span="colSpan">
        <el-form-item :label="$t('goodsPage.spuName')" prop="name">
          <BjInput v-model="queryParams.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('goodsPage.spuCode')" prop="spuCode">
          <BjInput v-model="queryParams.spuCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable @keyup.enter.native="handleQuery" />
        </el-form-item>
      </el-col> -->
      <el-col :span="colSpan">
        <el-form-item :label="$t('goodsPage.productTypes')" prop="type">
          <BjSelectLov v-model="queryParams.type" :option-list="GOODS_TYPE_LIST" :placeholder="$t('chooseText')" />
        </el-form-item>
      </el-col>
      <el-col :span="colSpan">
        <el-form-item :label="$t('goodsPage.categoryName')" prop="categoryIdList">
          <BjGoodsTypeTreeSelect v-model="queryParams.categoryIdList" :limit="1" multiple />
        </el-form-item>
      </el-col>
    </template>
    <template v-slot:tableOperation>
      <el-col v-if="setFlag == GOODS_COMBO_TYPES.ORDINARY">
        <el-button v-permission:BusinessGoodsSpuOrdinary_DownloadTemplate type="primary" disabled @click="onDownload">{{ $t('downloadTemplateText') }}</el-button>

        <el-button v-permission:BusinessGoodsSpuOrdinary_ImportData type="primary" disabled @click="onLead">{{ $t('importDataText') }}</el-button>

        <el-button v-show="setFlag == GOODS_COMBO_TYPES.ORDINARY" v-permission:BusinessGoodsSpuOrdinaryAdd type="primary" class="main-btn" @click="onAdd">
          {{ $t('goodsPage.generalMerchandise') }}</el-button>
      </el-col>
      <el-col v-if="setFlag == GOODS_COMBO_TYPES.PACKAGE">
        <el-button v-permission:BusinessGoodsSpuPackage_DownloadTemplate type="primary" disabled @click="onDownload">{{ $t('downloadTemplateText') }}</el-button>

        <el-button v-permission:BusinessGoodsSpuPackage_ImportData type="primary" disabled @click="onLead">{{ $t('importDataText') }}</el-button>
        <el-button v-show="setFlag == GOODS_COMBO_TYPES.PACKAGE" v-permission:BusinessGoodsSpuPackageAdd type="primary" class="main-btn" @click="onAdd">
          {{ $t('goodsPage.packageProduct') }}</el-button>

        <!-- <el-button type="primary"  @click="onDeleteSelected">批量删除</el-button> -->

        <!-- <el-button type="primary"  @click="onSubmitSelected">提交审核</el-button> -->
      </el-col>
    </template>
    <template v-slot:tableColumn>
      <template v-for="(col, index) in dropCols">
        <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="col.prop === 'code'" class="link" @click="onView(scope.row)">
              {{ scope.row[col.prop] }}
            </span>
            <div v-else-if="col.prop == 'mainImage'" class="flex flex-spacearound">
              <BjViewUrl :url="scope.row[col.prop][0]" style="width: 90px" />
            </div>

            <span v-else-if="col.prop == 'type'">{{ $t(GOODS_TYPE_LIST.bjGet(scope.row[col.prop])) }}
            </span>
            <el-tag v-else-if="col.prop === 'status'" :type="scope.row.status ? 'success' : 'info'">{{ $t(STATUS_ENABLED_NUM.bjGet(scope.row[col.prop])) }}</el-tag>
            <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
          <template slot-scope="props">
            <el-button v-permission:BusinessGoodsSpuOrdinaryView type="text" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
            <el-button v-permission:BusinessGoodsSpuOrdinaryEdit :disabled="props.row.todo1 == 2" type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
            <el-button v-permission:BusinessGoodsSpuOrdinary_Status type="text" @click="onStatus(props.row)">{{ props.row.status ? $t('disableText') : $t('enableText') }}</el-button>
            <!-- <el-button type="text"  @click="onSubmit(props.row)">{{ $t('submitText') }}</el-button> -->
            <el-button v-permission:BusinessGoodsSpuOrdinary_Delete type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
          </template>
        </el-table-column>
      </template>
    </template>
  </BjPage>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { goodsApi } from '@/api';
import { GOODS_TYPE_LIST, STATUS_ENABLED_NUM, GOODS_COMBO_TYPES } from '@/utils/constants';
export default {
  name: 'BusinessGoodsSpuOrdinaryIndex',
  mixins: [pageMiXin],
  props: {
    setFlag: {
      type: [String, Number],
      default: GOODS_COMBO_TYPES.ORDINARY,
    },
  },
  data() {
    return {
      selection: false,
      GOODS_TYPE_LIST,
      STATUS_ENABLED_NUM,
      GOODS_COMBO_TYPES,
      queryApi: goodsApi.getPage,
      colSpan: 6,
      // 查询参数
      queryParams: {
        setFlag: this.setFlag,
        spuCode: null,
        name: null,
        type: null,
        categoryIdList: [],
      },
      labelsVersion: 11,
    };
  },
  computed: {
    labelList() {
      const TEMP = [
        { label: 'goodsPage.categoryName', prop: 'categoryName', isCheck: true, disabled: false, width: 160 },
        // { label: 'goodsPage.spuName', prop: 'name', isCheck: true, disabled: false, width: 160 },
        // { label: 'goodsPage.spuCode', prop: 'spuCode', isCheck: true, disabled: false, width: 160 },
        { label: 'goodsPage.productTypes', prop: 'type', isCheck: true, disabled: false, width: 80 },
        { label: 'goodsPage.brandNameTable', prop: 'brandName', isCheck: true, disabled: false },
        // { label: 'goodsPage.materialNameText', prop: 'materialName', isCheck: true, disabled: false },
        { label: 'table.remarkText', prop: 'remark', isCheck: true, disabled: false },
        { label: 'table.statusText', prop: 'status', isCheck: true, disabled: false, width: 80 },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 170 },
      ];
      // 套餐列表，没有品牌字段
      if (this.setFlag) {
        TEMP.splice(4, 1);
      }
      return TEMP;
    },
  },
  watch: {},
  mounted() {},
  methods: {
    /** 下载模板 */
    onDownload() {},
    /** 导入数据 */
    onLead() {},
    /** 新建 */
    onAdd() {
      if (this.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
        this.$toPage('BusinessGoodsSpuOrdinaryAdd');
      }
      if (this.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
        this.$toPage('BusinessGoodsSpuPackageAdd');
      }
    },
    /** 编辑操作 */
    onEdit(row) {
      if (this.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
        this.$toPage('BusinessGoodsSpuOrdinaryEdit', { id: row.id });
      }
      if (this.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
        this.$toPage('BusinessGoodsSpuPackageEdit', { id: row.id });
      }
    },

    /** 查看 */
    onView(row) {
      if (this.setFlag == GOODS_COMBO_TYPES.ORDINARY) {
        this.$toPage('BusinessGoodsSpuOrdinaryView', { id: row.id });
      }
      if (this.setFlag == GOODS_COMBO_TYPES.PACKAGE) {
        this.$toPage('BusinessGoodsSpuPackageView', { id: row.id });
      }
    },

    /** 禁用 */
    onStatus(row) {
      const TEXT = row.status ? this.$t('disableText') : this.$t('enableText');
      this.$confirm(`${this.$t('toast.youAreTipText')} ${TEXT} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.operationApi({
            ids: [row.id],
            status: row.status ? 0 : 1,
          });
        })
        .catch(() => {});
    },
    /** 删除操作 */
    onDelete(row) {
      this.$confirm(`${this.$t('toast.youAreTipText')} ${this.$t('delText')} ${row.name}，${this.$t('toast.continueTipText')}`, this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: [row.id] });
        })
        .catch(() => {});
    },
    /** 批量删除操作 */
    onDeleteSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },

    onSubmitSelected() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('chooseText'));
        return;
      }
      // const ids = this.selectedRows.map(e => e.id);
      this.$confirm(this.$t('goodsPage.confirm1'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
        .then(() => {
          this.$message.info(this.$t('goodsPage.msgWarning'));
          // this.batchDeleteApi({ ids: ids });
        })
        .catch(() => {});
    },
    operationApi(API_DATA) {
      goodsApi.operation(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // deleteApi(API_DATA) {
    //   goodsApi.deleteOnlineShop(API_DATA).then(res => {
    //     if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
    //       this.$message.success(this.$t('toast.operationSuccessText'));
    //       setTimeout(() => {
    //         this.reFresh();
    //       }, 500);
    //     }
    //   });
    // },
    batchDeleteApi(API_DATA) {
      goodsApi.batchDelete(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item {
  .el-image {
    width: 200px;
  }
}
</style>
